import { render } from "./flex-box.vue?vue&type=template&id=5c74dc98&scoped=true"
import script from "./flex-box.vue?vue&type=script&lang=js"
export * from "./flex-box.vue?vue&type=script&lang=js"

import "./flex-box.vue?vue&type=style&index=0&id=5c74dc98&lang=scss&scoped=scoped"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c74dc98"]])

export default __exports__